import { Inject, Injectable, OnDestroy } from "@angular/core";

import { Subscription } from "rxjs";

import { CustomerService } from "@hermes/api-model-editorial";
import { LOCALE } from "@hermes/app-core";

import { AlternateService } from "@hermes/fragments/alternates";

import { Locale } from "@hermes/locale";
import { CustomerServiceContactFacade } from "@hermes/states/customer-service-contact";

import { HeadService } from "@hermes/utils-generic/services/head";
import { UrlUtils } from "@hermes/utils-generic/services/user-interface";

import { HomePageStructuredData } from "./home-page-analytics.model";
const HOMEPAGE_TITLE = $localize`:@@hermes-seo-head-title:The official Hermes online store`;
const HOMEPAGE_DESCRIPTION = $localize`:@@hermes-seo-metas.social-share.description.fallback:Discover all the collections of Hermès, fashion accessories, scarves and ties, belts and ready-to-wear, perfumes, watches and jewelry.`;

@Injectable()
export class HomePageHeadService implements OnDestroy {
    private subscription = new Subscription();

    constructor(
        @Inject(LOCALE) private locale: Locale,
        private headService: HeadService,
        private alternateService: AlternateService,
        private customerServiceContactFacade: CustomerServiceContactFacade,
        public urlUtils: UrlUtils,
    ) {}

    public setHeadData(): void {
        this.headService.setTitle(HOMEPAGE_TITLE, true);
        this.alternateService.addGenericAlternatesUrls();
        this.headService.addCanonicalUrl(
            decodeURI(this.urlUtils.getCurrentUrl()),
        );
        this.headService.addDescriptionMetaInformations(HOMEPAGE_DESCRIPTION);
        this.addHomePageStructuredData();
    }

    public addHomePageStructuredData(): void {
        this.subscription.add(
            this.customerServiceContactFacade
                .getCustomerServiceContacts()
                .subscribe((customerServiceContacts) => {
                    this.headService.addScript(
                        JSON.stringify(
                            this.getStructuredDataForHomePage(
                                customerServiceContacts,
                            ),
                        ),
                        "application/ld+json",
                        "HomePageStructuredData",
                    );
                }),
        );
    }
    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    public getStructuredDataForHomePage(
        customerServiceContacts: CustomerService[] | undefined,
    ): HomePageStructuredData {
        return {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "@context": "http://schema.org",
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "@type": "Organization",
            name: "Hermès",
            url: this.urlUtils.getCurrentUrl(),
            logo: "assets.hermes.com/is/image/hermesedito/hermes-logo",
            contactPoint: customerServiceContacts
                ? customerServiceContacts?.map((contact) => ({
                      // eslint-disable-next-line @typescript-eslint/naming-convention
                      "@type": "ContactPoint",
                      telephone: contact.phone,
                      contactType: contact.description,
                      areaserved: this.locale.countryCode,
                  }))
                : undefined,
        };
    }
}
